import NBType from '@netbase/nb-type'

const GeoFencingLonLatSchema = NBType.object().shape('GeoFencingLonLatSchema', {
  /* @prop */
  lat: NBType.number(),
  /* @prop */
  lon: NBType.number()
  /* END */
})
export default GeoFencingLonLatSchema
// RESERVE BELOW
